import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';

import VBToolTip from '../../MyComponents/Tooltip/VBToolTip';

// GitHub-style calendar of daily login counts for the last 100 days.
// `counts` is [{ day: <epoch day>, count: '12' }] from /admin/overview.

const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

function buildCountSlots(counts) {
    let monthSlots = [];
    let slotDayIndex = -1;
    let slotWeekIndex = -1;
    if (counts && counts.length > 0) {
        let countStart = counts[0].day;
        for (let i = countStart; i < counts[counts.length - 1].day + 1; i++) {
            let el = counts.find((e) => e.day === i);
            let date = new Date(i * 24 * 60 * 60 * 1000);
            if (!el) {
                el = { day: i, count: '0' };
            }
            let month = monthSlots.find((e) => e.month === MONTHS[date.getMonth()]);
            if (!month) {
                monthSlots.push({ month: MONTHS[date.getMonth()], weeks: [] });
                slotWeekIndex = -1;
                slotDayIndex = -1;
            }
            month = monthSlots.find((e) => e.month === MONTHS[date.getMonth()]);
            let weeks = month.weeks;
            if (slotWeekIndex === -1) {
                weeks.push({ days: [] });
                slotWeekIndex = 0;
            }
            let days = weeks[slotWeekIndex].days;
            let currentDay = date.getDay();
            if (slotDayIndex === -1) {
                for (let i = 0; i < currentDay; i++) {
                    days.push({ date, count: 0 });
                }
                slotDayIndex = currentDay;
            }

            days.push({ date, count: +el.count });
            slotDayIndex = currentDay;
            if (slotDayIndex >= 6) {
                slotDayIndex = -1;
                weeks.push({ days: [] });
                slotWeekIndex++;
            }
        }
    }
    return monthSlots;
}

function computeBackground(val) {
    if (val > 0 && val < 100) {
        return '#9CC069';
    }
    if (val >= 100 && val < 200) {
        return '#669D45';
    }
    if (val >= 200 && val < 300) {
        return '#637939';
    }
    if (val >= 300 && val < 800) {
        return '#3A6427';
    }
    if (val >= 800) {
        return '#12230b';
    }
    return '#EDEDED';
}

const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

const LoginHeatmap = ({ counts }) => {
    let months = buildCountSlots(counts);
    if (!months || months.length === 0) {
        return <Typography color="textSecondary">No logins recorded in the last 100 days.</Typography>;
    }

    return (
        <Grid container direction="row" spacing={2}>
            {months.map((month) => (
                <Grid item xs={12} sm={6} md={4} key={`day-render-month-${month.month}`}>
                    <Typography>{month.month}</Typography>
                    <div style={{ display: 'inline-flex' }}>
                        {month.weeks.map((week, index) => (
                            <div key={`day-render-month-day-${month.month}-week-${index}`}>
                                {week.days.map((day, index1) => (
                                    <VBToolTip
                                        content={
                                            <Typography>
                                                {`${day?.count ? day?.count : 0}`}
                                                {' logins : '}
                                                {day.date.toLocaleDateString(undefined, dateOptions)}
                                            </Typography>
                                        }
                                        key={`day-render-month-day-${month.month}-week-${index}-day${index1}`}
                                    >
                                        <div
                                            style={{
                                                width: '2.6rem',
                                                height: '1.8rem',
                                                lineHeight: '1.8rem',
                                                textAlign: 'center',
                                                fontSize: '0.75rem',
                                                color: day?.count >= 200 ? '#fff' : '#1D2130',
                                                background: computeBackground(day?.count),
                                            }}
                                        >
                                            {day?.count || ''}
                                        </div>
                                    </VBToolTip>
                                ))}
                            </div>
                        ))}
                    </div>
                </Grid>
            ))}
        </Grid>
    );
};

export default LoginHeatmap;
